<template>
  <div class="address_wrapper">
    <div class="input_entry">
      <van-field
        v-model="addressObj.orderNo"
        placeholder="订单号（可不填）"
        style="margin-bottom:12px"
        :border="false"
      />

      <van-field
        v-model="addressObj.name"
        placeholder="收件人姓名"
        style="margin-bottom:12px"
        :border="false"
      />

      <van-field
        v-model="addressObj.mobile"
        placeholder="手机号码"
        style="margin-bottom:12px"
        :border="false"
      />

      <!-- <van-field
        v-model="addressObj.addressStr"
        rows="5"
        autosize
        type="textarea"
        placeholder="详细地址：广东省 广州市 天河区 XXXXXX"
        :border="false"
      /> -->
      <van-field v-model="addressDetails.province" label="省" placeholder="请输入省" required :border="false" />
        <van-field v-model="addressDetails.city" label="市" placeholder="请输入市" required :border="false" />
        <van-field v-model="addressDetails.area" label="区" placeholder="请输入区" required :border="false" />
        <van-field v-model="addressDetails.details" label="详细地址" placeholder="请输入详细信息" required :border="false" rows="5" type="textarea" />
    </div>
    <div class="btn_wrapper">
      <van-button
        round
        type="info"
        class="buy_btn"
        color="#f93244"
        :disabled="
          !addressObj.name || !addressObj.mobile || !addressObj.addressStr
        "
        @click="handleEditOk"
        >保存修改</van-button
      >
    </div>
    <div class="cancel_btn" @click="handleCancel">取消</div>
  </div>
</template>

<script>
import { setAddressRsult } from '@/utils/addressUtil';
import Vue from 'vue';
export default {
  data() {
    return {
      addressObj: {},
      addressDetails: { province: '', city: '', area: '', details: '' },
    };
  },
  mounted() {
    const arr = Vue.ls.get('addressList');
    let newArr = arr.filter((item) => {
      return item.id == Number(this.$route.query.id);
    });
    const { province, city, county, address } = newArr[0]
    this.addressObj = newArr[0];
    Object.assign(this.addressDetails, { province, city, area: county, details: address })
  },
  methods: {
    handleEditOk() {
      const { addressObj } = this;
      //姓名长度
      if (addressObj.name.split('').length > 10) {
        return this.$toast.fail('姓名长度不能超过10');
      }
      //电话格式不对
      if (!/^((\+?86)|(\(\+86\)))?-?1[3456789]\d{9}$/.test(addressObj.mobile)) {
        return this.$toast.fail('请填写正确的手机号码');
      }

      const { province, city, area, details } = this.addressDetails
      Object.assign(addressObj, { province, city, county: area, address: details })

      // //编辑成功后要再次识别地址
      // const addressAll = setAddressRsult(addressObj.addressStr);
      // // 模糊匹配bug
      // // 识别后的省市区  与 输入字符串的  匹配程度  要大于识别的省市区的字数的一半
      // let test =
      //   addressAll.province +
      //   addressAll.city +
      //   addressAll.county +
      //   addressAll.address;
      // let testArr = test.split('');
      // let test2 = [];
      // testArr.forEach((item) => {
      //   if (addressObj.addressStr.indexOf(item) > -1) {
      //     test2.push(item);
      //   }
      // });
      // if (test2.length < testArr.length * 0.6) {
      //   return this.$toast.fail('请填写正确的地址');
      // }
      // addressObj.province = addressAll.province;
      // addressObj.city = addressAll.city;
      // addressObj.county = addressAll.county;
      // addressObj.address = addressAll.address;

      const arr = Vue.ls.get('addressList');
      arr.forEach((item, index) => {
        if (arr[index].id == addressObj.id) {
          arr[index] = addressObj;
        }
      });

      Vue.ls.set('addressList', arr);
      this.$router.push('/buy');
    },

    handleCancel() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.address_wrapper {
  background: #f7f8fa;
  height: 100vh;
}

.input_entry {
  background: #fff;
  padding-top: 3.2vw;
}
.btn_wrapper {
  display: flex;
  justify-content: center;
  margin-top: 23.333vw;
  margin-bottom: 4.267vw;
  .buy_btn {
    width: 91.467vw;
    height: 11.733vw;
  }
}
.cancel_btn {
  font-size: 4.533vw;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
}
/deep/.van-field__control {
  font-size: 4vw;
  line-height: 5.067vw;
}
</style>
